import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';


// Tabs
import DrowsinessSchedulesEditTab from './Elements/DrowsinessSchedulesEditTab';
import DrowsinessScheduleTestTab from './Elements/DrowsinessScheduleTestTab';
import DrowsinessScheduleResultTab from './Elements/DrowsinessScheduleResultTab';
import getLocale from '../../i18n/getLocale';

const PropTypes = require('prop-types');

class DrowsinessSchedulesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      file: {
        class: '',
        status_str: '',
        status_alt_str: '',
        id: '',
      },
      redirect_url: false,
      loaded: 0,
      actual_id: this.props.match.params.id,
      key: 1,
      drowsiness_schedule_data: {},
      updated: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.confirmChangeStatus = this.confirmChangeStatus.bind(this);

    this.locale = getLocale();
  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if((this.state.loaded === 1 && prevState.loaded === 0)) {
      this.setState({actual_id: this.props.match.params.id});
      this.setState({loaded: 2}, this.loadData());
    }
    if((this.props.match.params.id !== this.state.actual_id)) {
      this.handleAlert('', '', 'open');
      this.setState({actual_id: this.props.match.params.id});
      var responseJson = {data: '', status: '', message: ''};
      this.updateData(responseJson);
    }
  }

  updateData (responseJson) {
    this.setState({updated: 1}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/sonolencia/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas/sonolencia');
        if (responseJson.status === 'success') {
          self.setState({
            drowsiness_schedule_data: responseJson.data.drowsiness_schedule_data,
            drowsiness_schedule_applicability: responseJson.data.drowsiness_schedule_data.applicability_id,
            drowsiness_schedule_tests: responseJson.data.drowsiness_schedule_tests,
            staff_list: responseJson.data.staff_list,
            drowsiness_schedule_reports: responseJson.data.reports,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (self.state.updated == 1) {
          self.handleAlert(event.message, event.status, 'open');
          self.setState({updated: 0});
        } else {
          self.handleMessage();
        }
      }); /* Overlay */
    });
  }

  confirmChangeStatus(event) {
    this.handleAlert('', '', 'open');
    var url = event.currentTarget.value;
    var confirm = this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscala;
    if(url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/aprovado') {
      confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaAprovado);
    } else if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/finalizado') {
      confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaFinalizado);
    }
    if (confirm) {
      this.setState({
        modal_change_status: false,
        iframe: 'iframe-hidden',
      });
      var datasave = {};
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  changeStatus(url) {
    var confirm = this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscala;
    if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/aprovado') {
      confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaAprovado);
    } else if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/finalizado') {
      confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaFinalizado);
    }
    if (confirm) {
      var datasave = {};
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={self.handleLoaded} />
  <Overlay overlay={self.state.overlay} handleAlert={self.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.titulo}</h3>

      {/* Botão de fichas */}
      <div className="grid-buttons pull-right">
        <Dropdown id="revisions">
          <Dropdown.Toggle bsStyle={'danger'}>
            <i className="fa fa-fw fa-certificate"></i> {self.state.drowsiness_schedule_data.status_str}
          </Dropdown.Toggle>
            {(self.state.drowsiness_schedule_data.status === 'rascunho') ? 
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={self.changeStatus} eventKey={'/escala/sonolencia/' + self.state.drowsiness_schedule_data.id + '/trocar/status/aprovado'}>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.botaoDeFichas.TrocarParaAprovado}</MenuItem>
              </Dropdown.Menu>
            : 
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={self.changeStatus} eventKey={'/escala/sonolencia/' + self.state.drowsiness_schedule_data.id + '/trocar/status/finalizado'}>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.botaoDeFichas.TrocarParaFinalizado}</MenuItem>
              </Dropdown.Menu>
            }
        </Dropdown>
        <Link to="/escalas/sonolencia" className="btn btn-default"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>


      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.tituloTab}>
          <DrowsinessSchedulesEditTab updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} drowsiness_schedule_id={self.props.match.params.id} drowsiness_schedule_data={self.state.drowsiness_schedule_data} />
        </Tab>
        <Tab eventKey={2} title={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tituloTab}>
          <DrowsinessScheduleTestTab RequestApi={self.refs.request_api} updateData={self.updateData} status={self.state.drowsiness_schedule_data.status} updated={self.state.updated} handleAlert={self.handleAlert} drowsiness_schedule_id={self.props.match.params.id} drowsiness_schedule_data={self.state.drowsiness_schedule_data} drowsiness_schedule_tests={self.state.drowsiness_schedule_tests} staff_list={self.state.staff_list} drowsiness_schedule_status={self.state.drowsiness_schedule_status}/>
        </Tab>
        <Tab eventKey={3} title={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloTab}>
          <DrowsinessScheduleResultTab RequestApi={self.refs.request_api} updateData={self.updateData} status={self.state.drowsiness_schedule_data.status} updated={self.state.updated} handleAlert={self.handleAlert} drowsiness_schedule_id={self.props.match.params.id} drowsiness_schedule_reports={self.state.drowsiness_schedule_reports} drowsiness_schedule_status={self.state.drowsiness_schedule_status} drowsiness_schedule_applicability={self.state.drowsiness_schedule_applicability} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

DrowsinessSchedulesEdit.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default DrowsinessSchedulesEdit;



// WEBPACK FOOTER //
// ./src/Components/DrowsinessSchedules/DrowsinessSchedulesEdit.js